// ts-check
import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  taxonomyDetailsHeader: {
    id: 'course-authoring.taxonomy-detail.side-card.header',
    defaultMessage: 'Detalles de la taxonomía',
  },
  taxonomyDetailsName: {
    id: 'course-authoring.taxonomy-detail.side-card.name',
    defaultMessage: 'Título',
  },
  taxonomyDetailsDescription: {
    id: 'course-authoring.taxonomy-detail.side-card.description',
    defaultMessage: 'Descripción',
  },
  taxonomyDetailsExportID: {
    id: 'course-authoring.taxonomy-detail.side-card.exportID',
    defaultMessage: 'ID de exportación',
  },
});

export default messages;
